import "./article_bti_frontpage.css";

export default (article) => {
	const pageColor = article?.metaDynamic?.Farge?.value;
	document.getElementById("maincontent").classList.add(pageColor);
	document.getElementById("warnings_container").classList.add(pageColor);
	document.querySelector(".footer__pre").classList.add();

	return `<div class="row justify-content-md-center ${article.pageTypeId}">
      <div class="col-md-10 col-lg-7">
        ${article.mainImage} 
      </div>
        
      <div class="col-md-10 col-lg-7">
        <div class="article__template__${article.pageTypeId} p-0">
          <h1 class="article__header">${article.title}</h1> ${
						article.parsedIntro.length > 2
							? `<div class="article__intro">${article.parsedIntro}</div>`
							: ""
					}<div class="article__content ck-content">
           ${article.content}
         </div>
            </div>
        </div>
        ${
					article.hasRightColumn
						? `<div class="col-sm-4 offset-sm-1">${article.rightColumn}</div>`
						: ""
				}
    </div>`;
};
